$(document).ready(function(){
  //featured collection section slider 
    var swiper = new Swiper(".swiper-container", {
      slidesPerView: 1,
//         loop: true,
//        centeredSlides: true,
     grabCursor: true,
      draggable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
         breakpoints: {
            0: {
              slidesPerView: 1,
            },
            480: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 4,
            },
          },
    });

  //team section slider 

   var swiper = new Swiper(".itg_team", {
         slidesPerView: 5,
         spaceBetween: 0,
          loop: true,
        navigation: {
          nextEl: ".swiper-but-next",
          prevEl: ".swiper-but-prev",
        },
          breakpoints: {
            0: {
          slidesPerView: 1,
        },
         320: {
          slidesPerView: 2,
        },    
        480: {
          slidesPerView: 3,
          spaceBetween: 5,
        },
        767: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 5,
        },
      }
      });


  //testimonial section slider
  var swiper = new Swiper(".itg_testimonial_slider", {   
    slidesPerView: 3,  
     spaceBetween: 10,
     centeredSlides: true,
      loop: true,
         navigation: {
           nextEl: ".swiper-btn-next",
           prevEl: ".swiper-btn-prev",
         },
          breakpoints: {
            0: {
          slidesPerView: 1,
          centeredSlides: false,
        },
        320: {
          slidesPerView: 1,
          centeredSlides: false,
        },
        767: {
          slidesPerView: 2,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 3,
        },
      }
        
  });

  //subcollection slider
   // var swiper = new Swiper(".itg_subcollection_slider", {   
   //  slidesPerView: 5,
   //    loop: true,
   //       autoplay: {
   //        delay: 2500,
   //        disableOnInteraction: false,
   //      }
        
   //    });
  
  //mega menu 
  $('ul.list-menu.list-menu--inline li.itg_sidebar_style_menu .mega-menu__content ul.mega-menu__list li:first-child').addClass('active');
  $('ul.list-menu.list-menu--inline li.itg_sidebar_style_menu .mega-menu__content ul.mega-menu__list li').mouseover(function(){
      $(this).parents('ul.mega-menu__list').find('li.active').removeClass('active');
      $(this).addClass('active');
  
  });

  //videoplay btn
  $('.itg_playbtn').click(function(){
    $('.itg_video_main_div .deferred-media__poster').hide();
    $('#video').get(0).play();
  });

  //product color slider 
   var swiper = new Swiper(".slider_color", {
         slidesPerView: 4,
         spaceBetween: 10,
          loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

    //product page
    var qty_val = $( "#qty_option option:selected" ).val();
    $('#quantity_box').val(qty_val);
    $('#qty_option').on('change', function() {
      var valdata = $(this).val();
      $('#quantity_box').val(valdata);
    });

   $(".order_sample").click(function(e) {
      var variant_id = $(this).attr('data-variantid');
       if(variant_id != ''){
      var old_variant_id = $('.itg_option').val();
      $('.itg_option').val(variant_id);
      $('.product-form__submit').click();
      $('.itg_option').val(old_variant_id); 
      }
    });



  $(".request_price").click(function(e) {
    $('.request_form').show();
    });
    $(".close_icon").click(function(e) {
    $('.request_form').hide();
    });

    $(".tab_list span").click(function(e) {
        var tabName = $(this).attr('data-name');
        $(this).addClass('active_tabs').siblings().removeClass('active_tabs');
        $('.tab_details .tab_content').each(function() {
          var tabName_box = $(this).attr('data-name');
          if (tabName_box == tabName) {
            $(this).addClass('active_content');
          }else{
            $(this).removeClass('active_content');
          }
        })
    });
  //collection page list view and grid view js

  $('.square-btn').on('click', function(e) {
    $('ul#product-grid').removeClass('itg_grid');
    $('ul#product-grid').removeClass('itg_list');
   // $('ul#product-grid').removeClass('itg_small_list');
  if ($(this).hasClass('itg_list')) {
    $('ul#product-grid').addClass('itg_list');
    var coll_view_click = $(this).closest('li').attr('data-list');
    localStorage.setItem('collection_view', coll_view_click);
    //localStorage.setItem('collection_view', $('.collection').html());
  } else if ($(this).hasClass('itg_grid')) {
    $('ul#product-grid').addClass('itg_grid');
    var coll_view_click = $(this).closest('li').attr('data-list');
    localStorage.setItem('collection_view', coll_view_click);
    //localStorage.setItem('collection_view', $('.collection').html());
  }
  //else if ($(this).hasClass('itg_small_list')) {
  //  $('ul#product-grid').addClass('itg_small_list');
  //}
});
  if (window.localStorage.getItem('collection_view') != null) {
    
      if(localStorage.getItem('collection_view') == 'list_view'){
        $('.itg_list_grid_view .itg_list').trigger('click');
      }
      else if(localStorage.getItem('collection_view') == 'grid_view'){
        $('.itg_list_grid_view .itg_grid').trigger('click');
      }
   // alert(col_len);
  //$('.product-grid-container .collection').html(window.localStorage.getItem('collection_view'));
  }
  //collection page wishlist toggel
  $('.AddToWishDropArrow').click(function(){
    $(this).closest('.itg_btn_group').siblings('.itg_group_data').slideToggle();
  });


//collection ajax custom filter 
  function itgFilter(){
    	var collection_url = $(document).find('.itg_filter_maindiv').attr('data-url');
      	var tag_list = '/';
        $(document).find('.main-filter.active_box').find('input').each(function(index){
          if( index == 0 ){
            tag_list += $(this).val();         	
          }else{
            tag_list += '+'+$(this).val(); 
          }
        });
      	collection_url +=tag_list;
        $.ajax({
          type: 'GET',
          url: collection_url,
          beforeSend: function() {
          },
          success: function(data) {
            var itg_product_count = $(data).find(".itg_product_count").html();
            var collectionGrid = $(data).find(".itg_filter_maindiv").html();
            $(document).find('.itg_product_count').html(itg_product_count);
            $(document).find('.itg_filter_maindiv').html(collectionGrid);
            var obj = { Title: 'ChangeUrl', Url: collection_url };  
    		history.pushState(obj, obj.Title, obj.Url);        
          },
          dataType: "html"
        }); 
    $('.itg_collection_img_slider').slick('unslick');
    setTimeout(function() {

 $('.itg_collection_img_slider').slick({
    dots: false,
    autoplay: false,
    autoplaySpeed: 1000,
    arrows: false,
   fade: true,
  });
    $('.itg_collection_img_slider').mouseover(function() {
        $(this).slick('play')
    });
    $('.itg_collection_img_slider').mouseout(function() {
        $(this).slick('pause')
    });
                    }, 2500);

  }
  /*
  $(document).on('click','.itg_filter ul.nav li label',function(e){
    e.preventDefault();
    if( $(this).closest('.main-filter').hasClass('active_box') ){
    	$(this).closest('.main-filter').removeClass('active_box');
        $(this).find('.itg_checkbox').removeClass('itg_check');
    }else{    	
    	$(this).closest('.main-filter').addClass('active_box');
        $(this).find('.itg_checkbox').addClass('itg_check');
    }
    itgFilter();
  });
*/


  //local storage 
//Collection page 
  // $('.itg_show_filter').on("click", function(){
  //  $(this).parents('.itg_filter_maindiv').toggleClass('itg_nofilter_apply');
  // });

  //product image
  $('.product__media-item').each(function(){
    
  var img_alt = $(this).find('.product__media img').attr('alt');
  //alert(img_alt);
    if(img_alt == 'hide'){
      $(this).css("display", "none");
    }
  });
  $('.thumbnail-list__item').each(function(){
    
  var thumbimg_alt = $(this).find('.thumbnail img').attr('alt');
 if(thumbimg_alt == 'hide'){
      $(this).css("display", "none");
    }
  });
  $('.product-media-modal__dialog .product-media-modal__content img').each(function(){
        if(($(this).attr('alt')) == 'hide' ){
          $(this).css("display", "none");
        } 
  });


  ////product sku get 
  var product_url = $('.list_sku').attr('data-url');
  if(product_url != ''){
    
  $('.list_sku li').each(function() {
    var skuItem = $(this).attr('data-value');
    var url = product_url+'/search?q="'+skuItem+'"&view=search_sku';
    count = 1;
    $.ajax({
           type: 'GET',
           url: url,
           dataType: 'HTML',
           success: function(data) { 
           var sku_data = $(data).find('.itg_sku_item').html();
           $('.hide_sku_get').append(sku_data);   
           $('.hide_sku_get .item_name').each(function name(params) {
             var sku = $(this).attr('data-sku');
             if(sku == skuItem){
                $('.slider_color .swiper-wrapper').append($(this).html()); 
             }
           })
            // $('.slider_color .swiper-wrapper').append(HTMLDIV);
           }
       }); 
  });   
  }

//calculator page 
   $('#itg_calculator_form').on('submit', function (e) {
      e.preventDefault();  
    var first_wall = 1;
    var second_wall = 1;
    var third_wall = 1;
    var four_wall = 1;
    $('.itg_cal_for_group .itg_calculate_field').each(function(){
      if($(this).hasClass('itg_wall1')){
        var input_data= $(this).val();
        first_wall= first_wall * input_data; 
      }   
      if($(this).hasClass('itg_wall2')){
        var input_data= $(this).val();
        second_wall= second_wall * input_data; 
      }   
      if($(this).hasClass('itg_wall3')){
        var input_data= $(this).val();
        third_wall= third_wall * input_data; 
      }   
      if($(this).hasClass('itg_wall4')){
        var input_data= $(this).val();
        four_wall= four_wall * input_data; 
      }   
      //alert(input_data);
  });

    var total_wall = first_wall + second_wall + third_wall + four_wall;
    var single_wall= Math.ceil(total_wall/ 24);
     //alert(single_wall);
    if (single_wall % 2 === 0)  {
     // alert('even')
    }  //invalid markup I know!
   else {
     var single_wall= single_wall + 1;
   }
    var double_wall= Math.ceil(total_wall/ 48);
    // alert(double_wall);
    if (double_wall % 2 === 0)  {
      //alert(double_wall);
    }  //invalid markup I know!
   else {
     var double_wall= double_wall;
   }
    
    $('.itg_single_rolls').val(single_wall);
    $('.itg_double_rolls').val(double_wall);
  });

  //collection page custom compare btn click
$('.itg_hover_icon .itg_compare_btn').on('click', function (e) {
  $(this).parents('.card-wrapper').find('label.SPCMP_chk_lbl').trigger('click');
  $(this).toggleClass('active');
});
  $('.itg_list_view_data .itg_compare').on('click', function (e) {
  $(this).parents('.card-wrapper').find('label.SPCMP_chk_lbl').trigger('click');
  $(this).toggleClass('active');
});
  
  $('label.SPCMP_chk_lbl .SPCMP_Add:checked').each(function(){
    $(this).parents('.card-wrapper').find('.itg_hover_icon .itg_compare_btn').addClass('active');
  });
  
   

  //menu hover 
  // $('.header.itg_header nav.header__inline-menu li.itg_sidebar_style_menu').mouseover(function() {
  //   $('.header.itg_header nav.header__inline-menu li.itg_sidebar_style_menu .mega-menu').attr('open', false);
  //   $(this).find('.mega-menu').attr('open', true);
  // });
  //  $('.header.itg_header nav.header__inline-menu li.itg_sidebar_style_menu').mouseout(function(){   
  //    $('.header.itg_header nav.header__inline-menu li.itg_sidebar_style_menu .mega-menu').attr('open', false);
  //  });
  
   
  if( $(document).find('.itg_filters_main').length ){
    var collectionId = $(document).find('.itg_filters_main').data('id');
    if( collectionId !== '' ){
      //$(document).find('body').addClass('itg-loading');
      var currentTags = $(document).find('.itg_filters_main').data('current');
      var form_data = {
        collectionid : collectionId,
        current : currentTags
      };
      $.ajax({
          type: 'POST',
          url: 'https://mahoneswallpapershop.net/app/filter/config.php',
          data: form_data,	
          dataType: "json",			
          success: function( response ){ 
            console.log(response);
            var responseTags = response.data;
             if( responseTags != '' ){
              var $html = '';
              $html +='<div class="filter_header"><h3 class="header_text">Filter</h3><span class="itg_filter_icon itg_filter_close"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">       <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path></svg></span></div> <div class="itg_filter">';
              $html +='<button class="accordion active"><h5>Collection</h5></button>';
                $html +='<div class="panel">';
                  $html +='<ul class="nav">';
                    $.each( responseTags, function( key, value ) {
                      if( value != '' ){
                        var valueHandle = value.toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '').replace(/\./g, '');
                        var valueTitle = value.split("_");
                        if( value.indexOf('Collection_') != -1 ){
                          if( valueTitle[1] != '' ){
                            var valueTitleHandle = valueTitle[1].toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '');
                            $html +='<li class="collection-sidebar__filter-item main-filter" data-check="'+value+'" data-title="'+valueTitleHandle+'" data-tag="'+valueHandle+'"><label for="'+valueHandle+'"><input class="itg-filter-tag" type="checkbox" name="Collection" id="'+valueHandle+'" value="'+valueHandle+'"><span class="itg_checkbox"></span> <span class="itg_filter_text">'+valueTitle[1]+'</span></label></li>';
                          }
                        }
                      }
                    });
                  $html +='</ul>';
                $html +='</div>';
              $html +='</div>';
              $html +='<div class="itg_filter">';
              $html +='<button class="accordion active"><h5>Color</h5></button>';
                $html +='<div class="panel">';
                  $html +='<ul class="nav">';
                    $.each( responseTags, function( key, value ) {
                      if( value != '' ){
                        var valueHandle = value.toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '').replace(/\./g, '');
                        var valueTitle = value.split("_");
                        if( value.indexOf('Color_') != -1 ){
                          if( valueTitle[1] != '' ){
                            var valueTitleHandle = valueTitle[1].toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '');
                            $html +='<li class="collection-sidebar__filter-item main-filter" data-check="'+value+'" data-title="'+valueTitleHandle+'" data-tag="'+valueHandle+'"><label for="'+valueHandle+'"><input class="itg-filter-tag" type="checkbox" name="Collection" id="'+valueHandle+'" value="'+valueHandle+'"><span class="itg_checkbox"></span> <span class="itg_filter_text">'+valueTitle[1]+'</span></label></li>';
                          }
                        }
                      }
                    });
                  $html +='</ul>';
                $html +='</div>';
              $html +='</div>';
              $html +='<div class="itg_filter">';
              $html +='<button class="accordion active"><h5>Theme</h5></button>';
                $html +='<div class="panel">';
                  $html +='<ul class="nav">';
                    $.each( responseTags, function( key, value ) {
                      if( value != '' ){
                        var valueHandle = value.toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '').replace(/\./g, '');
                        var valueTitle = value.split("_");
                        if( value.indexOf('Theme_') != -1 ){
                          if( valueTitle[1] != '' ){
                            var valueTitleHandle = valueTitle[1].toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '');
                            $html +='<li class="collection-sidebar__filter-item main-filter" data-check="'+value+'" data-title="'+valueTitleHandle+'" data-tag="'+valueHandle+'"><label for="'+valueHandle+'"><input class="itg-filter-tag" type="checkbox" name="Collection" id="'+valueHandle+'" value="'+valueHandle+'"><span class="itg_checkbox"></span> <span class="itg_filter_text">'+valueTitle[1]+'</span></label></li>';
                          }
                        }
                      }
                    });
                  $html +='</ul>';
                $html +='</div>';
              $html +='</div>';
              $html +='<div class="itg_filter">';
              $html +='<button class="accordion active"><h5>Type</h5></button>';
                $html +='<div class="panel">';
                  $html +='<ul class="nav">';
                    $.each( responseTags, function( key, value ) {
                      if( value != '' ){
                        var valueHandle = value.toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '').replace(/\./g, '');
                        var valueTitle = value.split("_");
                        if( value.indexOf('Type_') != -1 ){
                          if( valueTitle[1] != '' ){
                            var valueTitleHandle = valueTitle[1].toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '');
                            $html +='<li class="collection-sidebar__filter-item main-filter" data-check="'+value+'" data-title="'+valueTitleHandle+'" data-tag="'+valueHandle+'"><label for="'+valueHandle+'"><input class="itg-filter-tag" type="checkbox" name="Collection" id="'+valueHandle+'" value="'+valueHandle+'"><span class="itg_checkbox"></span> <span class="itg_filter_text">'+valueTitle[1]+'</span></label></li>';
                          }
                        }
                      }
                    });
                  $html +='</ul>';
                $html +='</div>';
              $html +='</div>';
              $html +='<div class="itg_filter">';
              $html +='<button class="accordion active"><h5>Pasted</h5></button>';
                $html +='<div class="panel">';
                  $html +='<ul class="nav">';
                    $.each( responseTags, function( key, value ) {
                      if( value != '' ){
                        var valueHandle = value.toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '').replace(/\./g, '');
                        var valueTitle = value.split("_");
                        if( value.indexOf('Pasted_') != -1 ){
                          if( valueTitle[1] != '' ){
                            var valueTitleHandle = valueTitle[1].toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '');
                            $html +='<li class="collection-sidebar__filter-item main-filter" data-check="'+value+'" data-title="'+valueTitleHandle+'" data-tag="'+valueHandle+'"><label for="'+valueHandle+'"><input class="itg-filter-tag" type="checkbox" name="Collection" id="'+valueHandle+'" value="'+valueHandle+'"><span class="itg_checkbox"></span> <span class="itg_filter_text">'+valueTitle[1]+'</span></label></li>';
                          }
                        }
                      }
                    });
                  $html +='</ul>';
                $html +='</div>';
              $html +='</div>';
              $html +='<div class="itg_filter">';
              $html +='<button class="accordion active"><h5>Page</h5></button>';
                $html +='<div class="panel">';
                  $html +='<ul class="nav">';
                    $.each( responseTags, function( key, value ) {
                      if( value != '' ){
                        var valueHandle = value.toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '').replace(/\./g, '');
                        var valueTitle = value.split("_");
                        if( value.indexOf('Page_') != -1 ){
                          if( valueTitle[1] != '' ){
                            var valueTitleHandle = valueTitle[1].toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '');
                            $html +='<li class="collection-sidebar__filter-item main-filter" data-check="'+value+'" data-title="'+valueTitleHandle+'" data-tag="'+valueHandle+'"><label for="'+valueHandle+'"><input class="itg-filter-tag" type="checkbox" name="Collection" id="'+valueHandle+'" value="'+valueHandle+'"><span class="itg_checkbox"></span> <span class="itg_filter_text">'+valueTitle[1]+'</span></label></li>';
                          }
                        }
                      }
                    });
                  $html +='</ul>';
                $html +='</div>';
              $html +='</div>';
              $(document).find('.itg_filters_main').html($html);
              var stores_li = document.querySelectorAll('.collection-sidebar__filter-item');
                [].slice.call(stores_li).sort(function(a, b) {
                    var textA = a.getAttribute('data-title').toLowerCase()
                    var textB = b.getAttribute('data-title').toLowerCase()
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                }).forEach(function(el) {el.parentNode.appendChild(el)});
            }
            $(document).find('body').removeClass('itg-loading');
            $(document).find('.itg_filters_main').find('.itg_filter').each(function(){
              if( $(this).find('.collection-sidebar__filter-item').length ){
                $(this).removeClass('deactivate');
              }else{
                $(this).addClass('deactivate');
              }
            });
            var currentTagActive = $(document).find('.itg_filters_main').data('active');
            var currentTagActiveArray = currentTagActive.split(",");
            $(document).find('.collection-sidebar__filter-item').each(function(){
              var _value = $(this).data('check');
              var _this = $(this);
              $.each( currentTagActiveArray, function( key, value ) {
                if( _value == value ){
                  _this.find('.itg-filter-tag').prop('checked',true);
                }
              });
            });

            var activeFilter = 0;
            var activeFilterHtml = '';
                activeFilterHtml += '<label>Results for :</label>';
                activeFilterHtml += '<ul>';
            $.each( currentTagActiveArray, function( key, value ) {
              if( value.length > 0 ){
                var valueDetail = value.split("_");
                activeFilter = 1;
                activeFilterHtml += '<li><span data-tag="'+value+'">'+valueDetail[0]+' : '+valueDetail[1]+'</span></li>';
              }
            });
            activeFilterHtml += '</ul>';

            if( activeFilter === 1 ){
              $(document).find('.itg-active-filter').html(activeFilterHtml);
            }
            
          },
          error: function(data){
            console.log(data);
            // location.reload();
          }
      }); 
    }
    
    $(document).on('click','.accordion',function(){
      if( $(this).hasClass('active') ){
        $(this).closest('.itg_filter').find('.panel').slideUp();
        $(this).removeClass('active');
      }else{
        $(this).closest('.itg_filter').find('.panel').slideDown();
        $(this).addClass('active');
      }
    });
//custom filter btn on mobile 

$(".itg_filter_icon").on("click", function() {
    $('.itg_filters_main').css('right','0');
});
$(document).on('click','.itg_filter_close',function(){
     $('.itg_filters_main').css('right','-100%');
}); 
    /*
    function itgAjaxFilter(){
      var collectionUrl = $(document).find()
    }
    */
    
    $(document).on('change','.itg-filter-tag',function(){
      //itgAjaxFilter();
      var collectionUrl = $(document).find('.itg_filters_main').data('url');
      var tags = '';
      var count = 0;
      $(document).find('.itg-filter-tag').each(function(){
        if( $(this).is(':checked') ){
          if( count > 0 ){
            tags += '+'+$(this).val();
          }else{
            tags += $(this).val();
          }
          count = count+1;
        }
      });
      location.href=collectionUrl+"/"+tags;
    });

    $(document).on('click','.itg-active-filter span',function(){
      var current_tag = $(this).data('tag');
      $(document).find('.collection-sidebar__filter-item[data-check="'+current_tag+'"]').find('.itg-filter-tag').prop('checked',false).change();
    });
    
  }

   // collection page image slider
  $('.itg_collection_img_slider').slick({
    dots: false,
    autoplay: false,
    autoplaySpeed: 1000,
    arrows: false,
    fade: true,
  });
  
  $('.itg_collection_img_slider').mouseover(function() {
        $(this).slick('play')
    });
    $('.itg_collection_img_slider').mouseout(function() {
        $(this).slick('pause')
    });
  

////load more 
    $(document).on('click','#more a',function(e) {
    e.preventDefault();
    var scrollURL = $(this).attr("href");
    $.ajax({
           type: 'GET',
           url: scrollURL,
           beforeSend: function() {},
           success: function(data) {
               if( $(data).find("#more").length ){                 
                 var moreButton = $(data).find("#more").html();
                 $(document).find("#more").html(moreButton); 
                
               }else{                 
                 $(document).find("#more").remove();  
                 
               }
               var filteredData = $(data).find(".itg_collection_grid").html();
               $(document).find(".itg_collection_grid").append(filteredData);
             
                 
            
           },
           dataType: "html"
       });
      $('.itg_collection_img_slider').slick('unslick');
    setTimeout(function() {

 $('.itg_collection_img_slider').slick({
    dots: false,
    autoplay: false,
    autoplaySpeed: 1000,
    arrows: false,
   fade: true,
  });
    $('.itg_collection_img_slider').mouseover(function() {
        $(this).slick('play')
    });
    $('.itg_collection_img_slider').mouseout(function() {
        $(this).slick('pause')
    });
                    }, 2500);
setTimeout(function() {
      $(".order_sample").click(function(e) {
  var _this = $(this);
  var handleP = $(this).attr('data-ProductHandle');
    $.ajax({
      url: handleP,
      type:'GET',
      success: function(data){
        var idsv = $(data).find('.order_sample').attr('data-variantid');
        _this.attr('data-variantid', idsv);
        var variant_id = _this.attr('data-variantid');
        if(variant_id != ''){
          //alert(variant_id);
          var old_variant_id = _this.closest('.itg_collection_form').find('.itg_option').val();
          _this.closest('.itg_collection_form').find('.itg_option').val(variant_id);
          _this.closest('.itg_collection_form').find('.quick-add__submit').click();
          _this.closest('.itg_collection_form').find('.itg_option').val(old_variant_id); 
        }
      }
    });
    
    });
      }, 3000);
  });
  //collection page order sample
  $(".order_sample").click(function(e) {
  var _this = $(this);
  var handleP = $(this).attr('data-ProductHandle');
    $.ajax({
      url: handleP,
      type:'GET',
      success: function(data){
        var idsv = $(data).find('.order_sample').attr('data-variantid');
        _this.attr('data-variantid', idsv);
        var variant_id = _this.attr('data-variantid');
        if(variant_id != ''){
          //alert(variant_id);
          var old_variant_id = _this.closest('.itg_collection_form').find('.itg_option').val();
          _this.closest('.itg_collection_form').find('.itg_option').val(variant_id);
          _this.closest('.itg_collection_form').find('.quick-add__submit').click();
          _this.closest('.itg_collection_form').find('.itg_option').val(old_variant_id); 
        }
      }
    });
    
    });
});


